export default __webpack_public_path__ + "static/media/animal-11.60d27046.svg";